import React from 'react';

import { TextLabel } from 'uiToolkitV1/Typography';

const CAPTION_VARIANTS = {
  default: 'default',
  warning: 'warning',
  success: 'success',
  error: 'error',
};
const CAPTION_VARIANTS_COLORS = {
  default: '#999999',
  warning: '#8C6A00',
  success: '#2F8133',
  error: '#C62C02',
};
export const Caption = ({ children, variant = CAPTION_VARIANTS.default, props }) => (
  <TextLabel {...props} color={CAPTION_VARIANTS_COLORS[variant]}>
    {children}
  </TextLabel>
);
